import { type PaginationInput, getPaginationSkip } from '@pba/react-query';
import { useCallback } from 'react';
import type { MedicalGroupsListQueryFilter, MedicalGroupsListQuerySorter } from '#query-keys/medical-groups';
import { getOptionalStringValue, toNodeDateRangeQueryParameter, transformSortOrdersNode } from '#utils';
import type { MedicalGroupsRequestParams } from '../../../services';

type P = {
  filter?: MedicalGroupsListQueryFilter;
  pagination?: PaginationInput;
  sorter?: MedicalGroupsListQuerySorter;
};

export const useGetMedicalGroupsParameters = () =>
  useCallback(({ filter, pagination, sorter }: P): MedicalGroupsRequestParams => {
    const { pageSize, skip } = getPaginationSkip({ pagination });

    return {
      _id: filter?.ids ? { $in: filter.ids } : undefined,
      $limit: pageSize,
      $search: getOptionalStringValue(filter?.search),
      $skip: skip,
      $sort: transformSortOrdersNode({
        createdAt: sorter?.createdAt,
        name: sorter?.name,
      }),
      admin: filter?.admin,
      createdAt: toNodeDateRangeQueryParameter(filter?.range),
    };
  }, []);
